import React,{ useState, useEffect, useMemo } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import { downloadCsv } from '../common/sharedFunctions';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate,useLocation } from 'react-router-dom';
import moment from 'moment/min/moment-with-locales';
import {WEB_SECONDORY_COLOR } from "../common/sharedFunctions";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
import { useUsersPage } from '../common/useUsersPage';
import UsersPageFooter from '../components/UsersPageFooter';

export default function Users() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const navigate = useNavigate();
  const {
    deleteUser,
  } = api;
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null);
  const SECONDORY_COLOR = WEB_SECONDORY_COLOR(settings?.appCat);
  const {
    items,
    loading,
    error,
    hasMore,
    loadMore,
    refresh,
  } = useUsersPage('admin', {
    enabled: auth.profile?.usertype === 'admin',
  });
  const sortedData = useMemo(
    () => [...items].sort((a, b) => moment(b.createdAt) - moment(a.createdAt)),
    [items]
  );
  
  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  const columns = [
    { title: t('first_name'), field: 'firstName', initialEditValue: ''},
    { title: t('last_name'), field: 'lastName', initialEditValue: ''},
    { title: t('mobile'), field: 'mobile', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.mobile : t("hidden_demo")},
    { title: t('email'), field: 'email', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.email : t("hidden_demo"),headerStyle:{textAlign:'center'}},
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        ) : (
          <AccountCircleIcon sx={{ fontSize: 40 }} />
        ),
      editable: "never",
  },
  ];

  const [selectedRow, setSelectedRow] = useState(null);
  return (
    loading && !items.length ? <CircularLoading/>:
    <ThemeProvider theme={theme}>
    <MaterialTable
      title={t('alladmins_title')}
      columns={columns}
      onChangePage={(page)=>HandalePageChange(page)}
      style={{
        direction: isRTL === "rtl" ? "rtl" : "ltr",
        borderRadius: "8px",
        boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
        padding: "20px",
      }}
      data={sortedData}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={{
        initialPage:state?.pageNo,
        exportCsv: (columns, data) => {
          let hArray = [];
          const headerRow = columns.map(col => {
            if (typeof col.title === 'object') {
              return col.title.props.text;
            }
            hArray.push(col.field);
            return col.title;
          });
          const dataRows = data.map(({ tableData, ...row }) => {
            let dArr = [];
            for (let i = 0; i < hArray.length; i++) {
              dArr.push(row[hArray[i]]);
            }
            return Object.values(dArr);
          });
          const { exportDelimiter } = ',';
          const delimiter = exportDelimiter ? exportDelimiter : ',';
          const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join('\n');
          const csvFileName = 'download.csv';
          downloadCsv(csvContent, csvFileName);
        },
        exportButton: {
          csv: settings.AllowCriticalEditsAdmin,
          pdf: false,
        },
        maxColumnSort: "all_columns",
        rowStyle: rowData => ({
          backgroundColor: (selectedRow === rowData.tableData.id) ? colors.ROW_SELECTED : colors.WHITE
        }),
        ...TableStyle(settings)
      }}
      localization={localization(t)}
      editable={{
        onRowDelete: oldData => settings.AllowCriticalEditsAdmin ?
          new Promise(resolve => {
            setTimeout(() => {
              if(oldData.id === 'admin0001'){
                alert(t('admin_delete_error'));
                resolve();
              }else{
                resolve();
                dispatch(deleteUser(oldData.id));
              }
            }, 600);
          })
          :
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              alert(t('demo_mode'));
            }, 600);
          })
      }}
      actions={[
        {
          icon: 'add',
          tooltip: t('add_admin'),
          isFreeAction: true,
          onClick: (event) => navigate("/users/edituser/admin",{state:{pageNo:currentPage}}),
        },
        {
          icon: 'info',
          tooltip: t('profile_page_subtitle'),
          onClick: (event, rowData) => {
            navigate(`/users/adminupdate/${rowData.id}`,{state:{pageNo:currentPage}});
          },
        },
      ]}
    />
    <UsersPageFooter
      count={sortedData.length}
      hasMore={hasMore}
      loading={loading}
      error={error}
      onLoadMore={loadMore}
      onRetry={refresh}
    />
    </ThemeProvider>
  );
}
